import ScrollReveal from '../../../components/feature/ScrollReveal';

export default function DateBlock() {
  return (
    <section className="relative py-16 sm:py-32 px-4 sm:px-6" style={{ background: '#F5F0E8' }}>
      <div className="relative z-10 max-w-5xl mx-auto">
        <div className="text-center space-y-10 sm:space-y-14">

          <ScrollReveal direction="up">
            <div className="space-y-3">
              <h2 className="text-4xl sm:text-5xl md:text-6xl font-serif italic text-[#2A1A14]">
                Дата торжества
              </h2>
              {/* Ornamental divider under heading */}
              <div className="flex items-center gap-3 justify-center pt-2">
                <div className="h-px w-12 bg-[#A8323C]/50" />
                <span className="text-[#A8323C] text-sm">✦</span>
                <div className="h-px w-12 bg-[#A8323C]/50" />
              </div>
            </div>
          </ScrollReveal>

          <ScrollReveal direction="up" delay={220}>
            <div className="relative inline-block">
              {/* Shadow offset layer */}
              <div className="absolute inset-0 translate-x-2 translate-y-2 border border-[#A8323C]/20 bg-[#E8DDD0]" />

              {/* Main card */}
              <div className="relative bg-[#FDFAF4] border border-[#A8323C]/60 px-10 sm:px-16 md:px-20 py-8 sm:py-12 md:py-16"
                style={{ outline: '1px solid rgba(168,50,60,0.18)', outlineOffset: '6px' }}>

                {/* Corner flourishes */}
                {['top-2 left-2', 'top-2 right-2', 'bottom-2 left-2', 'bottom-2 right-2'].map((pos, i) => (
                  <span key={i} className={`absolute ${pos} text-[#A8323C] opacity-40 text-lg font-serif select-none`}>✦</span>
                ))}

                <div className="space-y-4 sm:space-y-6">
                  {/* Top label */}
                  <p className="text-xs tracking-[0.4em] uppercase text-[#8B6B5A] font-mono border-b border-[#A8323C]/20 pb-4">
                    День бракосочетания
                  </p>

                  <div className="text-center">
                    <div className="text-8xl sm:text-[9rem] md:text-[12rem] font-serif text-[#A8323C] leading-none"
                      style={{ textShadow: '2px 3px 0 rgba(168,50,60,0.12)' }}>
                      25
                    </div>
                  </div>

                  <div className="space-y-1 sm:space-y-2 border-t border-[#A8323C]/20 pt-4">
                    <p className="text-3xl sm:text-4xl md:text-5xl font-serif italic text-[#2A1A14]">
                      Июля
                    </p>
                    <p className="text-4xl sm:text-6xl md:text-7xl font-serif font-light text-[#2A1A14] tracking-widest">
                      2026
                    </p>
                  </div>

                  <div className="border-t border-[#A8323C]/20 pt-4">
                    <p className="text-sm sm:text-base tracking-[0.35em] uppercase text-[#8B6B5A] font-mono">
                      Суббота
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </ScrollReveal>
        </div>
      </div>
    </section>
  );
}
